import { useEffect, useState, useCallback, useRef } from 'react';

import { isEmpty } from 'ravenjs/utils/lodash';

import { CLICK_TO_BUY } from 'constants/clickToBuy';

export function useWHPPage({ history, generateC2BLeads, openC2BLeadGenerationConfirmationModal }) {
    const [subMenuTitle, setSubMenuTitle] = useState();
    const [currentPage, setCurrentPage] = useState(CLICK_TO_BUY.WHP.WHP_PAGES.COMPARISON_PAGE);
    const [quotation, setQuotation] = useState(null);

    const testimonialScreenRef = useRef(null);

    useEffect(() => {
        function getSubMenuTitle() {
            let title = '';
            switch (currentPage) {
                case CLICK_TO_BUY.WHP.WHP_PAGES.EMPLOYEE_COUNT_PAGE:
                    title = CLICK_TO_BUY.COMMON.EMPLOYEE_COUNT_VERIFICATION.SUB_NAV_TITLE;
                    break;
                case CLICK_TO_BUY.WHP.WHP_PAGES.PRICING_PAGE:
                    title = CLICK_TO_BUY.COMMON.PRICING_CONFIRMATION.TITLE.WHP;
                    break;
                default:
                    title = CLICK_TO_BUY.WHP.COMMON.BUTTONS.BACK;
            }
            return title;
        }

        setSubMenuTitle(getSubMenuTitle());
    }, [currentPage]);

    const onClickSubMenuBackButton = useCallback(() => {
        switch (currentPage) {
            case CLICK_TO_BUY.WHP.WHP_PAGES.EMPLOYEE_COUNT_PAGE:
                setCurrentPage(CLICK_TO_BUY.WHP.WHP_PAGES.COMPARISON_PAGE);
                break;
            case CLICK_TO_BUY.WHP.WHP_PAGES.PRICING_PAGE:
                setCurrentPage(CLICK_TO_BUY.WHP.WHP_PAGES.EMPLOYEE_COUNT_PAGE);
                break;
            default:
                if (window.history.length <= 1) {
                    history.push('/dashboard');
                } else {
                    history.goBack();
                }
        }
    }, [currentPage, history]);

    const redirectedToComparisonPage = useCallback(() => {
        setCurrentPage(CLICK_TO_BUY.WHP.WHP_PAGES.COMPARISON_PAGE);
    }, []);

    const redirectToViewCourseCatalog = useCallback(() => {
        history.replace(`/training/course-catalog`);
    }, [history]);

    function onClickGetPricing() {
        setCurrentPage(CLICK_TO_BUY.WHP.WHP_PAGES.EMPLOYEE_COUNT_PAGE);
    }

    function onClickViewCourseCatalog() {
        window.open('https://trustmineral.com/solutions/learn-course-catalogs/#whp', '_blank');
    }

    const onClickEmpCountVerificationOnCancel = useCallback(() => {
        setCurrentPage(CLICK_TO_BUY.WHP.WHP_PAGES.COMPARISON_PAGE);
    }, []);

    const onClickEmpCountVerificationOnContinue = useCallback(
        async (quotation, employeeCount = 0) => {
            if (!isEmpty(quotation.id)) {
                setQuotation({ ...quotation, employeeCount });
                setCurrentPage(CLICK_TO_BUY.WHP.WHP_PAGES.PRICING_PAGE);
            } else {
                await generateC2BLeads();
                openC2BLeadGenerationConfirmationModal(true, redirectToViewCourseCatalog);
            }
        },
        [generateC2BLeads, openC2BLeadGenerationConfirmationModal, redirectToViewCourseCatalog]
    );

    const onClickPricingConfirmationOnCancel = useCallback(() => {
        setCurrentPage(CLICK_TO_BUY.WHP.WHP_PAGES.COMPARISON_PAGE);
    }, []);

    const onClickPricingConfirmationOnCheckout = useCallback(
        async (paymentRedirectUrl, isCompleted = false) => {
            if (isCompleted) {
                // cancel ongoing timer on Testimonial page
                testimonialScreenRef.current?.cancelTimer();

                if (!isEmpty(paymentRedirectUrl)) {
                    window.open(paymentRedirectUrl, '_self');
                } else {
                    await generateC2BLeads();
                    openC2BLeadGenerationConfirmationModal(false, redirectToViewCourseCatalog);
                }
            } else {
                setCurrentPage(CLICK_TO_BUY.WHP.WHP_PAGES.TESTIMONIAL_PAGE);
            }
        },
        [generateC2BLeads, openC2BLeadGenerationConfirmationModal, redirectToViewCourseCatalog]
    );

    return {
        currentPage,
        onClickEmpCountVerificationOnCancel,
        onClickEmpCountVerificationOnContinue,
        onClickGetPricing,
        onClickPricingConfirmationOnCancel,
        onClickPricingConfirmationOnCheckout,
        onClickSubMenuBackButton,
        onClickViewCourseCatalog,
        quotation,
        redirectedToComparisonPage,
        subMenuTitle,
        testimonialScreenRef,
    };
}
